import { getQuestionnaireAnswers } from '@medplum/core';
import {
  Questionnaire,
  QuestionnaireItem,
  QuestionnaireResponse,
} from '@medplum/fhirtypes';

export function SignatureValidation(
  questionnaire?: Questionnaire,
  response?: QuestionnaireResponse
): void {
  if (!questionnaire?.item) {
    return;
  }

  const checkForSignature = (item: QuestionnaireItem): boolean => {
    if (item.item) {
      return (
        item.item.some(checkForSignature) || item.linkId.includes('-signature')
      );
    }
    return item.linkId.includes('-signature');
  };

  const hasSignature = questionnaire.item.some(checkForSignature);

  if (hasSignature) {
    if (!response) {
      throw new Error('No response');
    }

    const answers = getQuestionnaireAnswers(response);
    const signatureAnswerKey = Object.keys(answers).find((key) =>
      key.includes('-signature')
    );

    if (!signatureAnswerKey) {
      throw new Error('Signature is required but missing.');
    }

    const signatureAnswer = answers[signatureAnswerKey];
    if (!signatureAnswer?.valueAttachment) {
      throw new Error('Signature is required but not provided.');
    }
  }
}
